import {ChatMessageBase} from "../../molecules/ChatMessageBase/ChatMessageBase";
import React from "react";
import {MessageWithActionAndData} from "@me8eon/sessions_messages";

type Props = {
    message: MessageWithActionAndData;
    isLast: boolean;
}

export const UserMessageComponent: React.FC<Props> = ({message, isLast}) => {
    return <ChatMessageBase content={message.content} variant={"user"} isLast={isLast}/>
}